import { getLeagueFairMarketValues } from "./leagueFairMarkets";
// Only stored probabilities/fair markets. No xG forecast or model calculation.
export function storedModelOdd(record, market, outcome, line) {
  if (!record) return null;
  const p = record.probabilities;
  const probabilities = p ? {homewin:p.homewinprob,draw:p.drawprob,awaywin:p.awaywinprob} : {homewin:record.homewin,draw:record.draw,awaywin:record.awaywin};
  const keys = {"1":"homewin",X:"draw","2":"awaywin"};
  if (market === "1x2" || market === "double-chance") {
    const components = market === "1x2" ? [keys[outcome]] : {"1X":["homewin","draw"],"12":["homewin","awaywin"],"X2":["draw","awaywin"]}[outcome];
    if (!components || components.some(key => typeof probabilities[key] !== "number" || !Number.isFinite(probabilities[key]))) return null;
    const probability = components.reduce((sum,key) => sum + probabilities[key],0);
    return probability > 0 && probability <= 1 + 1e-9 ? 1 / probability : null;
  }
  const outcomes = market === "over-under" ? ["over","under"] : market === "asian-handicap" ? ["home","away"] : ["yes","no"];
  return getLeagueFairMarketValues(record, market, {goalLine:line,handicapLine:line,raw:true})[outcomes.indexOf(outcome)] ?? null;
}
